import "./_tab-cards.scss";

export default function TabCards() {
    const $tabCards = document.querySelectorAll('.tab-cards');

    if($tabCards.length) {
        $tabCards.forEach($item => {
            const $tabContent = $item.querySelectorAll('.tab-content');
            const $videoCards = $item.querySelectorAll('.video-card');
            const $imageCards = $item.querySelectorAll('.image-card');
            const $mask = $item.querySelector('.mask') as HTMLElement;
            const $closeBtn = $mask.querySelector('.close-btn') as HTMLElement;
            const $newsCards = $item.querySelectorAll('.news-card');
            const $liveEventCards = $item.querySelectorAll('.swiper-slide');

            $tabContent.forEach(($el, index) => {
                $el.setAttribute('id', `input-tab-${index}`)
            })

            function handleTabs() {
                const $tabs = $item.querySelectorAll('.tab');
                $tabs.forEach(($tab, index) => {
                    $tab.setAttribute('for', `input-tab-${index}`)
                    $tabs[0].classList.add('is-active');
                    const initialTabContentId = $tabs[0].getAttribute('for');
                    $tabContent.forEach((el) => {
                        if(el.getAttribute('id') === initialTabContentId) {
                            el.classList.add('checked')
                        }
                    })

                    $tab.addEventListener('click', () => {
                        $tabs.forEach($item => {
                            $item.classList.remove('is-active');
                        });
                        $tab.classList.add('is-active');
                        $tabContent.forEach((el) => {
                            if($tab.getAttribute('for') === (el.getAttribute('id'))) {
                                el.classList.add('checked')
                            } else {
                                el.classList.remove('checked')
                            }
                        })
                    })

                    $tab.addEventListener('keypress', function (e) {
                        // @ts-ignore
                        if (e.code === 'Enter') {
                            $tabs.forEach($item => {
                                $item.classList.remove('is-active');
                            });
                            $tab.classList.add('is-active');
                            $tabContent.forEach((el) => {
                                if($tab.getAttribute('for') === (el.getAttribute('id'))) {
                                    el.classList.add('checked')
                                } else {
                                    el.classList.remove('checked')
                                }
                            })
                        }
                    })
                })
            }

            handleTabs();

            if($newsCards.length === 0 && $liveEventCards.length === 0) {
                const $tabNews = $item.querySelector('.tab[for="input-tab-0"]') as HTMLElement;
                $tabNews.remove();

                const $nextTabVideo = $item.querySelector('.tab[for="input-tab-1"]') as HTMLElement;
                const $tabImage = $item.querySelector('.tab[for="input-tab-2"]') as HTMLElement;

                if ($nextTabVideo) {
                    $nextTabVideo.click();
                } else {
                    $tabImage && $tabImage.click();
                }
            }

            if ($videoCards.length) {
                $videoCards.forEach($el => {
                    const $video = $el.querySelector('video') as HTMLVideoElement;
                    const $playBtn = $el.querySelector('.play-btn') as HTMLElement;
                    const $title = $el.querySelector('.title-wrapper .title') as HTMLElement;
                    const $ytVideo = $el.querySelector('.yt-video') as HTMLIFrameElement;
                    const $modal = $item.querySelector('.modal-video') as HTMLElement;
                    const $modalVideo = $modal.querySelector('video') as HTMLVideoElement;
                    const $modalTitle = $modal.querySelector('.title') as HTMLDivElement;

                    if ($ytVideo) {
                        $el.classList.add('youtube-video');
                        $ytVideo.setAttribute('src', $ytVideo.src + '?enablejsapi=1');
                        const $videoCover = $el.querySelector('.video-yt-cover') as HTMLElement;
                        const $infoWrapper = $ytVideo?.parentElement?.querySelector('.info-wrapper') as HTMLElement;
                        const $titleWrapper = $ytVideo?.parentElement?.querySelector('.title-wrapper') as HTMLElement;

                        if($playBtn) {
                            window.addEventListener('load', () => {
                                $playBtn.addEventListener('click', () => {
                                    $videoCover.classList.add('d-none');
                                    $playBtn.classList.add('d-none');
                                    $infoWrapper.classList.add('d-none');
                                    $titleWrapper.classList.add('d-none');
                                    $ytVideo.setAttribute('src', $ytVideo.src + '&autoplay=1');
                                })
                            })
                        } else {
                            window.addEventListener('load', () => {
                                $el.addEventListener('click', () => {
                                    $infoWrapper.classList.add('d-none');
                                    $titleWrapper.classList.add('d-none');
                                    $ytVideo.setAttribute('src', $ytVideo.src + '&autoplay=1');
                                })
                            })
                        }
                    }

                    if($video) {
                        $modalVideo.controls = false;
                        $playBtn.addEventListener('click', () => {
                            $video.parentElement?.classList.add('full-screen');
                            $modal.classList.remove('d-none');
                            const $videoFull = $item.querySelector('.video-card.full-screen') as HTMLElement;
                            const videoSrc = ($videoFull.querySelector('video') as HTMLElement).getAttribute('src') as any;
                            $modalVideo.setAttribute('src', videoSrc);
                            $modalVideo.play();
                            $playBtn.classList.add('d-none');
                            $modalVideo.controls = true;
                            $mask.classList.remove('d-none');
                            document.body.style.overflow = 'hidden';
                            $modalTitle.innerText = $title.innerText;
                        })

                        $modalVideo.addEventListener('ended', () => {
                            closeModal();
                        })

                        $playBtn.addEventListener('keypress', function (e: KeyboardEvent) {
                            if (e.code === 'Enter') {
                                $modalVideo.play();
                                $modal.classList.remove('d-none');
                                $video.parentElement?.classList.add('full-screen');
                                $playBtn.classList.add('d-none');
                                $modalVideo.controls = true;
                                $mask.classList.remove('d-none');
                                document.body.style.overflow = 'hidden';
                            }
                        })

                        $closeBtn.addEventListener('click', () => {
                            closeModal();
                        })

                        $closeBtn.addEventListener('keypress', (e) => {
                            if(e.code === 'Enter') {
                                closeModal();
                            }
                        })

                        $mask.addEventListener('click', () => {
                            closeModal();
                        })

                        document.addEventListener('keydown', (e) => {
                            if(e.key === 'Escape') {
                                closeModal();
                            }
                        })

                        function closeModal() {
                            $playBtn.classList.remove('d-none');
                            $modal.classList.add('d-none');
                            $mask.classList.add('d-none');
                            document.body.style.overflow = 'scroll';
                            $video.parentElement?.classList.remove('full-screen');
                            $modalVideo.controls = false;
                            $modalVideo.load();
                            $video.controls = false;
                            $title.style.position = 'relative';
                        }

                        function secondsConvert(secondsDuration: any) {
                            var m = Math.floor(secondsDuration / 60);
                            secondsDuration = Math.floor(secondsDuration % 60);
                            secondsDuration = (secondsDuration >= 10) ? secondsDuration : "0" + secondsDuration;
                            return m + ":" + secondsDuration;
                        }

                        window.addEventListener('load', () => {
                            const $videoDuration = $el.querySelector('.time') as HTMLElement;

                            $videoDuration.innerHTML = secondsConvert($video.duration);
                        })
                    }
                })
            } else {
                const $tabVideo = $item.querySelector('.tab[for="input-tab-1"]') as HTMLElement;
                $tabVideo.remove();

                const $tabNews = $item.querySelector('.tab[for="input-tab-0"]') as HTMLElement;
                const $nextTabImage = $item.querySelector('.tab[for="input-tab-2"]') as HTMLElement;
                if (!$tabNews && $nextTabImage) {
                    $nextTabImage.click();
                } else {
                    $tabNews && $tabNews.click();
                }
            }

            if ($imageCards.length) {
                $imageCards.forEach($card => {
                    const $titleCard = $card.querySelector('.title') as HTMLDivElement;
                    const $modal = $item.querySelector('.modal-img') as HTMLElement;
                    const $modalImg = $modal.querySelector('img') as HTMLImageElement;
                    const $modalTitle = $modal.querySelector('.title') as HTMLDivElement;

                    $card.addEventListener('click', () => {
                        $modal.classList.remove('d-none');
                        $card.classList.add('full-screen');
                        const $cardFull = $item.querySelector('.image-card.full-screen') as HTMLElement;
                        const cardSrc = ($cardFull.querySelector('img') as HTMLElement).getAttribute('src') as any;
                        $modalImg.setAttribute('src', cardSrc);
                        $mask.classList.remove('d-none');
                        document.body.style.overflow = 'hidden';
                        $modalTitle.innerText = $titleCard.innerText;
                    })

                    $card.addEventListener('keypress', (e) => {
                        // @ts-ignore
                        if(e.code === 'Enter') {
                            $card.classList.add('full-screen');
                            $modal.classList.remove('d-none');
                            $mask.classList.remove('d-none');
                            document.body.style.overflow = 'hidden';
                        }
                    })

                    $closeBtn.addEventListener('click', () => {
                        closeModalImage();
                    })

                    $closeBtn.addEventListener('keypress', (e) => {
                        if(e.code === 'Enter') {
                            closeModalImage();
                        }
                    })

                    $mask.addEventListener('click', () => {
                        closeModalImage();
                    })

                    document.addEventListener('keydown', (e) => {
                        if(e.key === 'Escape') {
                            closeModalImage();
                        }
                    })

                    function closeModalImage() {
                        $modal.classList.add('d-none');
                        $mask.classList.add('d-none');
                        document.body.style.overflow = 'scroll';
                        $card.classList.remove('full-screen');
                    }
                })
            } else {
                const $tabImage = $item.querySelector('.tab[for="input-tab-2"]') as HTMLElement;
                $tabImage.remove();
            }

            if($imageCards.length === 0 && $videoCards.length === 0) {
                const $tabEvents = $item.querySelector('.tab[for="input-tab-0"]') as HTMLElement;
                if ($tabEvents) {
                    $tabEvents.click();
                }
            } else if($imageCards.length === 0 && $newsCards.length === 0 && $liveEventCards.length === 0) {
                const $tabVideo = $item.querySelector('.tab[for="input-tab-1"]') as HTMLElement;
                if ($tabVideo) {
                    $tabVideo.click();
                }
            } else if($videoCards.length === 0 && $newsCards.length === 0 && $liveEventCards.length === 0) {
                const $tabImage = $item.querySelector('.tab[for="input-tab-2"]') as HTMLElement;
                if ($tabImage) {
                    $tabImage.click();
                }
            }
        })
    }
}